<template>
    <component :is="icon"/>
</template>

<script>
import IconStar from '@/components/icons/IconStar.vue'
import IconTraffic from '@/components/icons/IconTraffic.vue'
import IconGasStation from '@/components/icons/IconGasStation.vue'
import IconEnvironmentZone from '@/components/icons/IconEnvironmentZone.vue'
import IconParking from '@/components/icons/IconParking.vue'
import IconTrainStation from '@/components/icons/IconTrainStation.vue'
import IconSights from '@/components/icons/IconSights.vue'
import IconOEAMTC from '@/components/icons/IconOEAMTC.vue'
import IconPercentage from '@/components/icons/IconPercentage.vue'
import IconReststop from '@/components/icons/IconReststop.vue'
import IconToll from '@/components/icons/IconToll.vue'
import IconTunnel from '@/components/icons/IconTunnel.vue'
import IconMountainRoad from '@/components/icons/IconMountainRoad.vue'
import IconCamping from '@/components/icons/IconCamping.vue'
import IconEasyWay from '@/components/icons/IconEasyWay.vue'
import IconBike from '@/components/icons/IconBike.vue'
import IconHealth from '@/components/icons/IconHealth.vue'
import IconWeather from '@/components/icons/IconWeather.vue'
import IconTravelRadar from '@/components/icons/IconTravelRadar.vue'
import IconChargingStation from '@/components/icons/IconChargingStation.vue'
export default {
    props: {
        icon: {
            type: String,
            default: ''
        }
    },
    components: {
        IconStar,
        IconTraffic,
        IconGasStation,
        IconEnvironmentZone,
        IconParking,
        IconTrainStation,
        IconSights,
        IconOEAMTC,
        IconPercentage,
        IconReststop,
        IconToll,
        IconTunnel,
        IconMountainRoad,
        IconCamping,
        IconEasyWay,
        IconBike,
        IconHealth,
        IconWeather,
        IconTravelRadar,
        IconChargingStation,
    },
}
</script>